import { render } from "./index.vue?vue&type=template&id=046e389a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=046e389a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-046e389a"

export default script